import { api, bareApi, type AuthUser, type SessionResponse } from './http';

export const loginRequest = (login: string, password: string) =>
  bareApi
    .post<SessionResponse>('/users/login', { login, password })
    .then((res) => res.data);
export const logoutRequest = () =>
  bareApi.post<{ ok: boolean }>('/users/logout').then((res) => res.data);

export const fetchMe = () =>
  api.get<AuthUser>('/users/me').then((res) => res.data);
